import { render, staticRenderFns } from "./TestimonialsCard.vue?vue&type=template&id=9d2d635a&"
import script from "./TestimonialsCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialsCard.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports